import React from "react";
import "./index.scss";
import { Row, Col, Card } from "react-bootstrap";
import { ButtonV1, Image } from "lib";
import LinkExpiryImage from "assets/images/LinkExpiry.svg";

const LinkExpiry = (props) => {
  const { header, content } = props;

  const handleCloseWindow = () => {
    window.close();
  };

  return (
    <Card className="cardStyle">
      <Card.Body>
        <Row className="align-items-center">
          <Col xs={12} className="text-center m-3">
            <Image
              imageSrc={LinkExpiryImage}
              altText="LinkExpiry"
              className="linkExpiryImage"
            />
          </Col>
          <Col xs={12} className="text-center">
            <label className="linkExpiryHeader">
              {header ? header : "This signature link has expired"}
            </label>
          </Col>
          <Col xs={12} className="text-center">
            <p className="linkExpiryContent">
              {content
                ? content
                : " Please contact your RM for resolving the concern."}
            </p>
          </Col>
          <Col xs={12} className="text-center">
            <ButtonV1
              label={"Okay"}
              onClick={handleCloseWindow}
              className="primary_button error_button_style"
              variant={"primary"}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LinkExpiry;
